import * as React from "react";
import * as _ from "underscore";
import { connect } from "react-redux";
import Select from "react-select";
import { Form, Button } from "react-bootstrap";

import { AppShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import APIClient from "../../APIClient";
import { ExplanationStatus } from "../../Explanations";

const trim = require("underscore.string/trim");
const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

interface EditorProps {
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class ClosingExplanationsHurdleEditor extends React.Component<EditorProps, any> {
  STATUS_OPTIONS = [
    { label: "Needs response", value: ExplanationStatus.needs_response },
    { label: "Needs review", value: ExplanationStatus.needs_review },
    { label: "Satisfactory", value: ExplanationStatus.satisfactory },
    { label: "Unsatisfactory", value: ExplanationStatus.unsatisfactory },
  ];

  constructor(props) {
    super(props);
    this.state = {
      message: "",
      explanations: _.where(this.props.app.explanations, {
        type_key: "Closing",
      }),
    };
  }

  createExplanation(e) {
    e.preventDefault();
    APIClient.post("/explanations", {
      loan_application_id: this.props.app.id,
      type: "Closing",
      message: this.state.message,
    }).then((responseObject: any) => {
      this.setState({
        message: "",
        explanations: this.state.explanations.concat(responseObject.explanation),
      });
    });
  }

  handleOnChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  statusChange(index, option) {
    const { explanations } = this.state;
    APIClient.put(`/explanations/${explanations[index].id}`, {
      status: option.value,
    }).then((responseObject: any) => {
      explanations[index] = responseObject.explanation;
      this.setState({ explanations });
    });
  }

  render() {
    const { app, hurdle, onHide } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <ul>
          {this.state.explanations.map((explanation, index) => (
            <li key={index}>
              <p>{explanation.message}</p>
              <p>{explanation.response}</p>
              {explanation.response_datetime.Valid && (
                <Select
                  clearable={false}
                  value={explanation.status}
                  options={this.STATUS_OPTIONS}
                  onChange={this.statusChange.bind(this, index)}
                />
              )}
            </li>
          ))}
        </ul>
        <Form onSubmit={this.createExplanation.bind(this)}>
          <textarea
            onChange={this.handleOnChange.bind(this)}
            name="message"
            value={this.state.message}
          />
          <Button type="submit" disabled={trim(this.state.message) === ""}>
            Submit
          </Button>
        </Form>

        <footer className={styles.footer}>
          <Button bsSize="small" onClick={onHide}>
            <i className="fa fa-thumbs-up" /> OK
          </Button>
        </footer>
      </HurdleView>
    );
  }
}

export default connect()(ClosingExplanationsHurdleEditor);
